import Filters from "../Filters";
import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class ComponentOptionsFilter {

    /** @type {function()} */
    #refreshFunction;
    /** @type {Map<string,Filter>} */
    #filters;
    /** @type {HTMLElement} */
    #inputTimeSelect;
    /** @type {HTMLElement} */
    #inputFilterSelect;
    /** @type {HTMLElement} */
    #inputSearch;
    /** @type {Filter[]} */
    #filterHandlers;

    /**
     *
     * @param refreshFunction {function()}
     */
    constructor(refreshFunction) {
        this.#refreshFunction = refreshFunction;
        this.#filterHandlers = [];
    }

    _createSelect() {
        let select = DomBuilder.element('select', { class: 'btn btn-secondary' });

        select.addEventListener('change', () => {
            this.#refreshFunction();
        });

        return select;
    }

    _createSearchBox() {
        let input = DomBuilder.element('input', { type: 'text', class: 'form-control', placeholder: 'Search (text or query)' });

        let keyupTimeoutID = 0;
        input.addEventListener('keydown', (e) => {
            if (e.key === "Escape") {
                clearTimeout(keyupTimeoutID);
                this.#inputSearch.value = '';
                this.#refreshFunction();
            }
        });
        input.addEventListener('input', (e) => {
            clearTimeout(keyupTimeoutID);
            keyupTimeoutID = setTimeout(() => {
                this.#refreshFunction();
            }, 500);
        });

        return input;
    }

    createNode() {
        this.#inputTimeSelect = this._createSelect();
        this.#inputFilterSelect = this._createSelect();
        this.#inputSearch = this._createSearchBox();
        return DomBuilder.div({ class: 'filter-component' }, [
            this.#inputTimeSelect,
            this.#inputFilterSelect,
            this.#inputSearch
        ]);
    }

    setFilters(filters) {
        this.#filters = filters;
        this.#inputFilterSelect.replaceChildren();
        this.#filterHandlers = [];

        filters.forEach((filter, name) => {
            this.#inputFilterSelect.append(DomBuilder.element('option', { value: String(this.#filterHandlers.length) }, name));
            this.#filterHandlers.push(filter);
        });
    }

    setTimeSpan(dateFrom, dateTo) {
        this.#inputTimeSelect.replaceChildren();
        this.#inputTimeSelect.append(DomBuilder.element('option', { value: '' }, '<all>'));

        if (dateFrom === null || dateTo === null) {
            return;
        }

        const yearFrom = Number.parseInt(dateFrom.substring(0, 4));
        const yearTo = Number.parseInt(dateTo.substring(0, 4));

        for (let year = yearTo; year >= yearFrom; year--) {
            this.#inputTimeSelect.append(DomBuilder.element('option', { value: String(year) }, '' + year));
        }
    }

    getAllFilters() {
        return this.#filters;
    }

    getCombinedFilter() {
        let selected = this.#inputFilterSelect.value;
        let filter = this.#filterHandlers[selected];

        let year = this.#inputTimeSelect.value;
        if (year) {
            filter = Filters.concat(Filters.createYearFilter(year), filter);
        }

        let search = this.#inputSearch.value;
        if (search !== '') {
            filter = Filters.concat(filter, Filters.createSearchFilter(search, this.#filters));
        }

        return filter;
    }
}
